import {
  PutApiIntegrationRequestBodyType,
  PutApiIntegrationResponseBodyType,
} from "@intelligems/ig-types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "../api";
import { integrationKeys } from "../queryKeys";
import { ApiRequest } from "../types/api";

const putApiIntegration = async (
  payload: ApiRequest<PutApiIntegrationRequestBodyType>
) => {
  const resp = await api.put<PutApiIntegrationResponseBodyType>(
    `/v2/integrations/api`,
    payload.body
  );
  return resp.data;
};

export const usePutApiIntegration = () => {
  const queryClient = useQueryClient();
  return useMutation<
    PutApiIntegrationResponseBodyType,
    Error,
    ApiRequest<PutApiIntegrationRequestBodyType>,
    any
  >({
    mutationFn: async (data: ApiRequest<PutApiIntegrationRequestBodyType>) =>
      putApiIntegration(data),
    onSuccess: async () => {
      void queryClient.invalidateQueries({ queryKey: integrationKeys.all });
    },
  });
};
